import React, { useState } from "react";
import axios from "axios";
import "./Payments.css";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:9777"
    : "http://192.168.0.2:9777";

function Payments() {
  const user = JSON.parse(localStorage.getItem("user"));

  const adminId = user?.adminId || user?.userId;
  const createdBy = user?.emailId;

  const [formData, setFormData] = useState({
    upiId: "",
    phonePeNumber: "",
    googlePayNumber: "",
    paytmNumber: "",
    bhimNumber: "",
    qrImage: null,
  });

  const [preview, setPreview] = useState("");

  const [errors, setErrors] = useState({});

  const validate = () => {
    const err = {};

    if (!formData.upiId.trim()) {
      err.upiId = "UPI ID is required";
    }

    if (!formData.phonePeNumber.trim()) {
      err.phonePeNumber = "PhonePe number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phonePeNumber)) {
      err.phonePeNumber = "Enter valid mobile number";
    }

    if (!formData.googlePayNumber.trim()) {
      err.googlePayNumber = "Google Pay number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.googlePayNumber)) {
      err.googlePayNumber = "Enter valid mobile number";
    }

    if (!formData.paytmNumber.trim()) {
      err.paytmNumber = "Paytm number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.paytmNumber)) {
      err.paytmNumber = "Enter valid mobile number";
    }

    if (!formData.bhimNumber.trim()) {
      err.bhimNumber = "BHIM number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.bhimNumber)) {
      err.bhimNumber = "Enter valid mobile number";
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setFormData({
      ...formData,
      qrImage: file,
    });

    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const data = new FormData();

      data.append("adminId", adminId);
      data.append("createdBy", createdBy);
      data.append("upiId", formData.upiId);
      data.append("phonePeNumber", formData.phonePeNumber);
      data.append("googlePayNumber", formData.googlePayNumber);
      data.append("paytmNumber", formData.paytmNumber);
      data.append("bhimNumber", formData.bhimNumber);

      if (formData.qrImage) {
        data.append("qrImage", formData.qrImage);
      }

      const response = await axios.post(`${API_BASE_URL}/payments/save`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.statusCode === 200) {
        alert("Payment Details Saved Successfully");

        setFormData({
          upiId: "",
          phonePeNumber: "",
          googlePayNumber: "",
          paytmNumber: "",
          bhimNumber: "",
          qrImage: null,
        });

        setPreview("");
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log(error);
      alert("Unable to save payment details.");
    }
  };

  return (
    <div className="paymentContainer">
      <div className="paymentHeader">
        <h2>Payment Settings</h2>
        <p>Add your UPI payment details.</p>
      </div>

      <form className="paymentForm" onSubmit={handleSubmit}>
        {" "}
        <div className="paymentGrid">
          {/* UPI ID */}
          <div className="paymentCard">
            <h3>UPI ID</h3>

            <input
              type="text"
              name="upiId"
              placeholder="example@upi"
              value={formData.upiId}
              onChange={handleChange}
            />

            {errors.upiId && <span className="error">{errors.upiId}</span>}
          </div>

          {/* PhonePe */}
          <div className="paymentCard">
            <h3>PhonePe</h3>

            <input
              type="text"
              name="phonePeNumber"
              placeholder="PhonePe Mobile Number"
              maxLength={10}
              value={formData.phonePeNumber}
              onChange={handleChange}
            />

            {errors.phonePeNumber && (
              <span className="error">{errors.phonePeNumber}</span>
            )}
          </div>

          {/* Google Pay */}
          <div className="paymentCard">
            <h3>Google Pay</h3>

            <input
              type="text"
              name="googlePayNumber"
              placeholder="Google Pay Mobile Number"
              maxLength={10}
              value={formData.googlePayNumber}
              onChange={handleChange}
            />

            {errors.googlePayNumber && (
              <span className="error">{errors.googlePayNumber}</span>
            )}
          </div>

          {/* Paytm */}
          <div className="paymentCard">
            <h3>Paytm</h3>

            <input
              type="text"
              name="paytmNumber"
              placeholder="Paytm Mobile Number"
              maxLength={10}
              value={formData.paytmNumber}
              onChange={handleChange}
            />

            {errors.paytmNumber && (
              <span className="error">{errors.paytmNumber}</span>
            )}
          </div>

          {/* BHIM */}
          <div className="paymentCard">
            <h3>BHIM</h3>

            <input
              type="text"
              name="bhimNumber"
              placeholder="BHIM Mobile Number"
              maxLength={10}
              value={formData.bhimNumber}
              onChange={handleChange}
            />

            {errors.bhimNumber && (
              <span className="error">{errors.bhimNumber}</span>
            )}
          </div>

          {/* QR Upload */}
          <div className="paymentCard qrCard">
            <h3>QR Code</h3>

            <input type="file" accept="image/*" onChange={handleImage} />

            {preview && (
              <div className="previewBox">
                <img src={preview} alt="QR Preview" className="qrPreview" />
              </div>
            )}
          </div>
        </div>
        <div className="buttonSection">
          <button type="submit" className="saveBtn">
            Save Payment Details
          </button>
        </div>
      </form>
    </div>
  );
}

export default Payments;
